import { AxiosError } from 'axios';
import { GET_DOWNLOAD_ENTRY_PROOF_FILE_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import { GET_DOWNLOAD_ENTRY_PROOF_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export enum RegistrationType {
  NATIONAL = 'NATIONAL',
  NON_NATIONAL = 'NON_NATIONAL',
}

interface DownloadEntryProofRequest {
  uuid: string;
  registrationType: RegistrationType;
}

export interface DownloadEntryProofResponse {
  url: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  downloadEntryProofRequest: DownloadEntryProofRequest;
  onSuccess?: (data: DownloadEntryProofResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetDownloadEntryProof = ({
  downloadEntryProofRequest,
  onSuccess,
  onError,
}: Input) => {
  const getDownloadEntryProof = async () => {
    const res = await axiosClient.get<DownloadEntryProofResponse>(
      GET_DOWNLOAD_ENTRY_PROOF_URL(
        downloadEntryProofRequest.uuid,
        downloadEntryProofRequest.registrationType
      )
    );
    return res.data;
  };

  return useCustomQuery(
    GET_DOWNLOAD_ENTRY_PROOF_FILE_QUERY_KEY.concat(downloadEntryProofRequest.uuid),
    getDownloadEntryProof,
    {
      enabled: false,
      onSuccess,
      onError,
    }
  );
};
